<!--
 * @Author: WLL
 * @Date: 2020-04-13 17:29:10
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-14 22:33:41
 * @Description: 菜单导航
 -->
<template>
  <div class="navBar">
    <router-link
      v-for="item in data"
      :key="item.value"
      :to="{ name: item.value }"
      tag="div"
      class="navItem"
      active-class="navItem--selected"
      @click.native="onRouterLinkClick(item)"
    >
      <i class="navItem_icon" :class="item.icon"></i>
      <div class="navItem_label">{{ item.label }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    value: [String, Number],
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onRouterLinkClick(item) {
      window.sendEvent("click_label", {
        label_name: item.label
      });
    }
  }
};
</script>

<style lang="less" scoped>
@navItem-height: 32px;

.navBar {
  .navItem {
    position: relative;
    height: @navItem-height;
    display: flex;
    align-items: center;
    color: @color-normal;
    cursor: pointer;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      color: @color-highlight-xh;
    }

    &.navItem--selected {
      color: @color-highlight-xh;

      &::after {
        content: "";
        position: absolute;
        right: 1px;
        top: 0px;
        bottom: 0px;
        width: 2px;
        background-color: @color-highlight-xh;
      }
    }

    .navItem_icon {
      margin-left: 11px;
      font-size: 15px;
    }
    .navItem_label {
      flex: 1;
      min-width: 0;
      margin-left: 11px;
      margin-right: 4px;
      .text("caption");
      .text-ellipsis();
      font-size: @xh-font-size;
    }
  }
}
</style>
